import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=63be1645&"
import script from "./Authorize.vue?vue&type=script&lang=js&"
export * from "./Authorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports